import { render, staticRenderFns } from "./DashboardBase.vue?vue&type=template&id=6702f814&"
import script from "./DashboardBase.vue?vue&type=script&lang=js&"
export * from "./DashboardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports